import L from 'leaflet';
import 'leaflet.heat';

// Leaflet.heat 0.2 / simpleheat reads the output bitmap on every redraw.
// Select the readback context before simpleheat requests the same canvas context.
const MonitoringHeatLayer = L.HeatLayer.extend({
    _initCanvas() {
        const canvas = this._canvas = L.DomUtil.create('canvas', 'leaflet-heatmap-layer leaflet-layer');
        const origin = L.DomUtil.testProp(['transformOrigin', 'WebkitTransformOrigin', 'msTransformOrigin']);
        canvas.style[origin] = '50% 50%';
        const size = this._map.getSize();
        canvas.width = size.x;
        canvas.height = size.y;
        canvas.getContext('2d', { willReadFrequently: true });
        const animated = this._map.options.zoomAnimation && L.Browser.any3d;
        L.DomUtil.addClass(canvas, `leaflet-zoom-${animated ? 'animated' : 'hide'}`);
        this._heat = window.simpleheat(canvas);
        this._updateOptions();
    },
});

export const monitoringHeatLayer = (points, options) => new MonitoringHeatLayer(points, options);
